module.exports = __webpack_public_path__ + "img/menu.d42f78d1.svg";